import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Pagination from "./Pagination";



function Favourites() {
  let genre = {28:"Action", 12:"Adventure", 16:"Animation", 35:"Comedy", 80:"Crime", 99:"Documentary", 18:"Drama",10751:"Family",14:"Fantasy",36: "History", 27: "Horror", 10402: "Music", 9648: "Mystery", 10749: "Romance", 878: "Sci-fi", 53: "Thriller", 10752: "war", 37: "Western"
}
  const [fav, setFav] = useState([]);
  const[movieList,setMovieList]=useState([]);
  useEffect(() => {
    axios.get("https://api.themoviedb.org/3/trending/all/day?api_key=bfc2dc001ad661990f954af88f5d31c6").then((res) =>
      setFav(res.data.results)
      // console.log(res.data.results)
    )
  }, [])


  useEffect(() => {
    axios.get("https://api.themoviedb.org/3/trending/all/day?api_key=bfc2dc001ad661990f954af88f5d31c6").then((res) =>
       setMovieList(res.data.results)
      // console.log(res.data.results)
    )
  }, [])
  const allGenres=()=>{
    let allMovie=[...movieList];
     setMovieList(allMovie)
  }
  const showSciFi=()=>{

  }
  return (
    <div>
      <div className='flex space-x-3 justify-center mt-10'>
        <button onClick={allGenres} className='text-3xl text-white bg-blue-600 font-bold border border-blue-700 rounded-3xl p-4
      '>All Genres</button>
        <button onClick={showSciFi} className='text-3xl font-bold border rounded-3xl p-4 w-[180px] border-blue-700 text-white bg-blue-600'>Sci-Fi</button>
        <button className='text-3xl font-bold border border-blue-700 rounded-3xl p-4 w-[180px] text-white bg-blue-600'>Action</button>
        </div>
      <div className='flex justify-center space-x-3 mt-10'>
        <input type="text" placeholder="Search" className='text-2xl rounded-3xl border font-semibold p-4 border-blue-700' />
        <input type="number" value={1} className='text-2xl border rounded-3xl font-semibold p-4 border-blue-700' />

      </div>
      <div>
        <div className="overflow-hidden rounded-lg border border-gray-200 shadow-md m-5">
          <table className="w-full border-collapse bg-white text-left text-sm text-gray-500 table-auto">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-4 font-medium text-gray-900">Name</th>
                <th>
                  <div className='flex space-x-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mt-4 border border-blue-400 rounded-3xl">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                    </svg>
                    <div scope="col" className="px-6 py-4 font-bold text-xl text-gray-900">Rating</div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mt-4 border border-blue-400 rounded-3xl">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </th>
                <th>
                  <div className='flex'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 border rounded-3xl border-blue-400 mt-4 ml-3">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                    </svg>

                    <div scope="col" className="px-6 py-4 text-gray-900 font-bold text-xl relative">Popularity</div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mt-4 border rounded-3xl border-blue-400">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </th>



                <th scope="col" className="px-6 py-4 font-bold text-xl text-gray-900 mr-5">Genre</th>
                <th scope="col" className="px-6 py-4 font-bold text-xl text-gray-900">Remove</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100 border-t border-gray-100">
              {fav.map((movie) => {

                return <tr className="hover:bg-gray-50" key={movie.id}>
                  <th className="flex items-center space-x-2 px-6 py-4 font-normal text-gray-900">

                    <img
                      className="h-[8rem] w-[8rem] object-fit"
                      src={`url(https://image.tmdb.org/t/p/original/t/p/${movie.poster_path})`}
                      alt=""
                    />
                    <span className="absolute right-0 bottom-0 h-2 w-2 rounded-full bg-green-400 ring ring-white"></span>
                    <div className="font-medium text-xl text-gray-700">{movie.title || movie.name}</div>
                  </th>
                  <td className="p-10 ml-32 text-bold text-2xl text-blue-500">
                    {movie.vote_average}
                  </td>
                  <td className="p-10 ml-36 text-bold text-2xl text-blue-500">{movie.popularity.toFixed(2)}</td>
                  <td className="px-6 py-4">
                    <div className="flex gap-2">
                      <span className='font-bold text-xl text-green-500'>{genre[movie.genre_ids[0]]}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">

                    <span className='text-red-500 font-bold text-xl'>Delete</span>

                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
        <div><Pagination></Pagination></div>

      </div>
    </div>
  )
}


export default Favourites;
